/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";

import { ProductPageHero } from "../blocks/Hero/ProductPageHero";
import { SearchFormLanding } from "../blocks/SearchForm/SearchFormLanding";
import { productTypeAccessory } from "../constants/productTypes";

export const DealerAccessoriesPage: FunctionComponent = () => {
  return (
    <>
      <ProductPageHero />
      <SearchFormLanding
        forcePrimaryManufacturers
        productType={productTypeAccessory}
      />
    </>
  );
};

/**
 * @see docs/worklog/TW-914-standalone-accessories-site-changes/rfc.md
 * @see docs/worklog/TW-914-standalone-accessories-site-changes/tfc.md
 */
